import React from 'react'

const HeatAirConditioning = ({ width = '41px', height = '40px', color }) => (
  <svg viewBox="0 0 41 40" version="1.1" xmlSpace="preserve" width={width} height={height}>
    <title>Heating AC@3x</title>
    <g id="Desktop" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
      <g id="Mechanical_D" transform="translate(-964.000000, -520.000000)" stroke={color}>
        <g id="Heating-AC" transform="translate(964.000000, 520.000000)">
          <path
            d="M20.9245833,20.2163542 L40.894375,20.2163542 M6.05322917,5.63583333 L12.9291667,12.5117708 M-2.250052e-13,20.1829167 L9.50989583,20.1829167 M6.14947917,34.6557292 L12.7928125,28.0123958 M39.71875,25.5907292 L34.3505208,20.2225 L39.5441667,15.0289583 M20.7513542,20.3732292 L34.795625,34.4175 M30.3496875,37.2342708 L30.3496875,30.0591667 L37.6340625,30.0591667 M20.7495833,19.7132292 L20.7495833,39.6948958 M20.9301042,33.6783333 L26.5965625,39.3447917 M20.7495833,20.0773958 L20.7495833,0 M26.266875,1.37197917 L20.89875,6.74010417 M20.7477083,20.2094792 L34.7992708,6.15791667 M37.7652083,10.7978125 L30.1734375,10.7978125 L30.1734375,3.40927083 M20.4447917,9.35729167 C14.44,9.71083333 9.6846875,14.4654167 9.6846875,20.27875 C9.6846875,26.1017708 14.4558333,30.8623958 20.4746875,31.2019792"
            id="Stroke-101"></path>
        </g>
      </g>
    </g>
  </svg>
)
export default HeatAirConditioning
